module.exports = __webpack_public_path__ + "img/img29.c887a971.png";